console.log('custom-dev-1.01');

!function(e){"function"==typeof define&&define.amd?define(["jquery"],e):"object"==typeof exports?module.exports=e(require("jquery")):e(jQuery)}(function(e){var n=/\+/g;function o(e){return t.raw?e:encodeURIComponent(e)}function i(e){return o(t.json?JSON.stringify(e):String(e))}function r(o,i){var r=t.raw?o:function(e){0===e.indexOf('"')&&(e=e.slice(1,-1).replace(/\\"/g,'"').replace(/\\\\/g,"\\"));try{return e=decodeURIComponent(e.replace(n," ")),t.json?JSON.parse(e):e}catch(e){}}(o);return e.isFunction(i)?i(r):r}var t=e.cookie=function(n,c,u){if(arguments.length>1&&!e.isFunction(c)){if("number"==typeof(u=e.extend({},t.defaults,u)).expires){var s=u.expires,a=u.expires=new Date;a.setMilliseconds(a.getMilliseconds()+864e5*s)}return document.cookie=[o(n),"=",i(c),u.expires?"; expires="+u.expires.toUTCString():"",u.path?"; path="+u.path:"",u.domain?"; domain="+u.domain:"",u.secure?"; secure":""].join("")}for(var d,f=n?void 0:{},p=document.cookie?document.cookie.split("; "):[],l=0,m=p.length;l<m;l++){var x=p[l].split("="),g=(d=x.shift(),t.raw?d:decodeURIComponent(d)),v=x.join("=");if(n===g){f=r(v,c);break}n||void 0===(v=r(v))||(f[g]=v)}return f};t.defaults={},e.removeCookie=function(n,o){return e.cookie(n,"",e.extend({},o,{expires:-1})),!e.cookie(n)}});


jQuery(document).ready(function () { 
  setTimeout(function(){
  var lang = jQuery('#ly-languages-switcher option:selected').text().toLowerCase();
  jQuery('body').attr('data-lang',lang);
  },2000);
  jQuery('#ly-languages-switcher').change(function(){
  	var lang2 = jQuery('#ly-languages-switcher option:selected').text().toLowerCase();
  	jQuery('body').attr('data-lang',lang2);
  });
  
  var w_width = jQuery(window).width();
  jQuery('.mm_wrap').css('width', w_width);

  //For 4 columns navigation
  jQuery('.mm_wrap div ul.column1').addClass("column2 custom_nav");  
  
  jQuery('.col_filter .mobile_filter').click(function(){
    if(jQuery(this).hasClass('active')){
      jQuery(this).removeClass('active').text('Categories filter');
      jQuery(this).next('ul.mobile_filter_list').slideUp('slow'); 	
      jQuery('.col_filter').removeClass('active');      	     
    }else{
    	jQuery(this).addClass('active').text('Hide Categories filter');
      	jQuery('.col_filter').addClass('active');
      	jQuery(this).next('ul.mobile_filter_list').slideDown('slow');
    }
  });
  
  // Testimonial slider
  jQuery('#testimonial_slider').flexslider({
    animation: "slide",
    controlNav: false,
    animationLoop: true,
    touch: true,    
    slideshow: false,
    itemWidth: 462,
    move: 1,
    minItems: 1,
    maxItems: 1,    
  });  
  
  //Announcement bar slider
  if(jQuery('.ab_wrap .flexslider').length > 0){
  jQuery('.ab_wrap .flexslider').flexslider({
    animation: "slide",
    controlNav: false,
    animationLoop: true,
    touch: true,    
    slideshow: true, 
    move: 1,
    minItems: 1,
    maxItems: 1,    
  });  
  }
  
  jQuery('.site-header__link.site-header__cart').mouseover(function(){
    if(jQuery(window).width() >= 768){
      $(this).click();
    }
  });  
            
  
});
jQuery(window).resize(function () {      
  var w_width = jQuery(window).width();
  
  jQuery('.mm_wrap').css('width', w_width);
 
  if(jQuery(".message-top-bar").css("display") == "block"){
    jQuery(".message-top-bar").animate({height: textHeight});
    var textHeight = jQuery(".message-content").outerHeight(true);
    jQuery(".message-top-bar").css("height", textHeight+"px");
    var bar_height = parseInt(20 + textHeight);
    jQuery(".header_message_slider").css("padding-top",(57 + textHeight)+"px");
    jQuery(".main-content").css("padding-top", bar_height);
  }
    
});

jQuery(window).load(function() {

  var cookie = jQuery.cookie("baracookieAccept");

  if(cookie != "true"){
    jQuery(".message-top-bar").css("display","block");
    var textHeight = jQuery(".message-content").outerHeight(true);
    jQuery(".message-top-bar").animate({height: textHeight});
    var bar_height = parseInt(20 + textHeight);
    jQuery(".header_message_slider").animate({paddingTop:57 + textHeight});
    jQuery(".main-content").css("padding-top", bar_height);
  }
});

jQuery(window).unload(function() {
  if(jQuery(".message-top-bar").css("display") == "block"){
    closeMessageBar();
  }
});

function closeMessageBar(){
  jQuery.cookie("baracookieAccept", "true", {expires : 30})
  jQuery(".message-top-bar").css("display","none");
  jQuery(".header_message_slider").css("padding-top", "57px");
  jQuery(".main-content").css("padding-top", '0px');
}